import { combineReducers } from "redux";

import authReducer from "./auth/reducer";
import getOrganizationAndRestaurantReducer from "./getOrganizationAndRestaurant/reducer";
import usersReducer from "./users/reducer";
import organizationsReducer from "./organizations/reducer";
import qrReducer from "./qr/reducer";
import discountReducer from "./discounts/reducer";
import salesInfoReducer from "./salesInfo/reducer";
import dashboardReducer from "./dashboard/reducer";
import organizationsStatisticsReducer from "./organizationsStatistics/reducer";
import tablesInfoReducer from "./tablesInfo/reducer";
import menuConfigurationReducer from "./menuConfiguration/reducer";
import waitersReducer from "./waiters/reducer";
import logsHistoryReducer from "./logsHistory/reducer";
import areasReducer from "./areas/reducer";
import driversReducer from "./drivers/reducer";
import reportsStatisticsReducer from "./reportsStatistics/reducer";
import restaurantSchemaReducer from "./restaurantSchema/reducer";
import restaurantReservationsReducer from "./reservations/reducer";
import reservationHistoryReducer from "./reservationHistory/reducer";
import myMenuOrdersReducer from "./myMenuOrders/reducer";
import ordersExecutionReducer from "./ordersExecution/reducer";
import usersReportsReducer from "./usersReports/reducer";
import myMenuSurveyReducer from "./myMenuSurvey/reducer";
import tablesEfficiencyReducer from "./tablesEfficiency/reducer";
import invoicesReducer from "./invoices/reducer";
import productProfitabilityReducer from "./productProfitability/reducer";

export default combineReducers({
  authReducer,
  getOrganizationAndRestaurantReducer,
  usersReducer,
  organizationsReducer,
  qrReducer,
  discountReducer,
  salesInfoReducer,
  dashboardReducer,
  organizationsStatisticsReducer,
  tablesInfoReducer,
  menuConfigurationReducer,
  waitersReducer,
  logsHistoryReducer,
  areasReducer,
  driversReducer,
  reportsStatisticsReducer,
  restaurantSchemaReducer,
  restaurantReservationsReducer,
  reservationHistoryReducer,
  myMenuOrdersReducer,
  ordersExecutionReducer,
  usersReportsReducer,
  myMenuSurveyReducer,
  tablesEfficiencyReducer,
  invoicesReducer,
  productProfitabilityReducer,
});
